module.exports = __webpack_public_path__ + "media/img/id-81394ed473d60bcc17db29d463dff7d6.png";